import * as React from 'react';
import styled from '@emotion/styled';
import { useNavigate } from 'react-router-dom';
import { useSystem } from '../../../hooks/useSystem';
import { ProfileRoutes } from '@foxbun/lib-goferal-types';
import { SimpleImageForm } from './SimpleImageForm';
import { Notification, NotificationType } from '../../../core/stores/NotificationStore';
import { AnimatePageWidget } from '../../../widgets/layout/AnimatePageWidget';
import { APP_ENV } from '../../../env';

export const UploadGalleryImagePage: React.FC = () => {
  const system = useSystem();
  const navigate = useNavigate();

  return (
    <AnimatePageWidget slide={true}>
      <S.Container>
        <SimpleImageForm
          label="Upload gallery image"
          handle={async ({ crop, upload }) => {
            let token = await system.session.token_wrapper.getToken();
            await upload.send(`${APP_ENV.API_SERVER}${ProfileRoutes.UPLOAD_GALLERY_IMAGE}`, token, crop);
            await system.user.loadGalleryImages();
            system.notification_store.showNotification(
              new Notification({
                type: NotificationType.SUCCESS,
                desc: 'Gallery image uploaded'
              })
            );
            navigate(system.user.link, { state: 'push' });
          }}
        />
      </S.Container>
    </AnimatePageWidget>
  );
};

namespace S {
  export const Container = styled.div`
    display: flex;
    align-items: stretch;
    flex-direction: column;
    row-gap: 10px;
    overflow: auto;
    margin: auto;
    height: 100%;
    width: 100%;
    max-width: 400px;
    padding: 10px;
    box-sizing: border-box;
  `;
}
